/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import PropTypes from '../util/prop_types';
import { SidePanelSelectors } from '../stores/sidepanel_selectors';
import { SidePanelActionCreators } from '../stores/sidepanel_action_creators';
import SearchResults from './search_results';


const mapStateToProps = (state) => {
  return {
    searchQuery: SidePanelSelectors.getQuery(state),
    isCollapsed: SidePanelSelectors.isCollapsed(state),
    isLoading: SidePanelSelectors.isLoading(state),
  }
}

const mapDispatchToProps = {
  toggleCollapsed: SidePanelActionCreators.toggleCollapsed
};

class SidePanel extends React.Component {
  static propTypes = {
    searchQuery: PropTypes.string.isRequired,
    isCollapsed: PropTypes.bool,
  }

  render(): ?React.Element<any> {
    const { props, state } = this;

    var className = "";

    if (props.isCollapsed) {
      className += " collapsed"
    }
    if (!!props.searchQuery) {
      className += " visible"
    }

    return (
      <div id="side-panel-container"
        className={className} >
        <div id="side-panel">
          <div className="omnibox-spacer" />
          {props.searchQuery != '' &&
            <SearchResults
              activeId={-1} />
          }
          {props.isLoading &&
            <div className="loading">
              <FontAwesome
                name="spinner"
                pulse
                size="3x"
                fixedWidth
                ariaLabel="Loading..." />
            </div>
          }
        </div>

        <div id="side-panel-toggle">
          <button
            aria-label={(props.isCollapsed) ? "Expand side panel": "Collapse side panel"}
            onClick={props.toggleCollapsed}>
            <FontAwesome
              name={(props.isCollapsed) ? 'caret-right' : 'caret-left'}
              fixedWidth />
          </button>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SidePanel);
